import { Injectable } from "@angular/core";
import { CH_METADATA_METHODS, ClareHomeRPCMethodNames, ClareHomeRPCServiceNames } from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy";

@Injectable({
    providedIn: "root",
})
export class EquatorServiceMetadataService {
    constructor(readonly equatorProxyService: EquatorProxyService) {}

    private call(uuid: string, method: ClareHomeRPCMethodNames, params: any[]) {
        return this.equatorProxyService.makeClareHomeRpcRequest$(
            uuid, // uuid
            ClareHomeRPCServiceNames.CH_METADATA, // service
            method, // method
            params // params
        );
    }

    get(uuid: string) {
        return this.call(uuid, CH_METADATA_METHODS.GET_SERVICE_METADATA, []);
    }
}
